var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"artistContainer",staticClass:"artist-row-container"},[_c('div',{ref:"artist",staticClass:"artist-row"})])}
var staticRenderFns = []

export { render, staticRenderFns }